export enum ReceiptType {
    Cash = 1,
    Refund = 2
}